// src/chains/cronos.js - Cronos Mainnet configuration
import { createChainConfig } from './chainConfig';

export const cronosConfig = createChainConfig({
  key: 'cronos',
  chainId: 25,
  name: 'Cronos Mainnet',
  rpcUrl: 'https://1rpc.io/cro',
  explorerUrl: 'https://cronoscan.com',
  
  // Native token information
  nativeTokenSymbol: 'CRO',
  nativeTokenName: 'Cronos',
  nativeTokenIcon: 'https://i.imgur.com/c7N7EBb.png',
  nativeTokenDecimals: 18,
  
  // Related token addresses
  wrappedNativeToken: '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23', // WCRO
  
  // Price and API endpoints
  coingeckoAPI: 'https://api.coingecko.com/api/v3/simple/price?ids=crypto-com-chain&vs_currencies=usd&include_24hr_change=true',
  coingeckoId: 'crypto-com-chain',
  geckoTerminalId: 'cro',
  tokenListUrl: 'https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/cronos.json',
  
  // SushiSwap configuration (if used)
  aggregatorAddress: 'SushiSwap', // Special value indicating SushiSwap API usage
  sushiswapConfig: {
    // Base URL of the SushiSwap API
    apiBaseUrl: 'https://api.sushi.com',
    // SushiSwap router address - will be obtained from the API response
    routerAddress: '0xAC4c6e212A361c968F1725b4d055b47E63F80b75' 
  },
  
  // Legacy aggregator reference
  legacyAggregatorAddress: '0xcd7d16fB918511BF7269eC4f48d61D79Fb26f918', // CronaSwap router
  
  // Transaction support
  supportsEIP1559: false,

  
  // Transaction history API
  txHistoryApi: 'https://api.cronoscan.com/api?module=account&action=txlist&address={address}',
});